import React from "react";
import { AlertOctagon, Star, X } from "lucide-react";

export function FaultDetailHeader({ fault, isAdmin, busy, onToggleCritical, onClose }) {
  return (
    <div className="sticky top-0 bg-white border-b border-[#E5E7EB] px-6 py-4 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="k-label">Fault detail</div>
        <h2 className="mt-1 text-xl font-heading font-bold text-[#212121] flex items-center gap-2">
          {fault.critical && <AlertOctagon className="h-4 w-4 text-[#B91C1C] shrink-0" />}
          <span className="truncate">{fault.rule}</span>
        </h2>
        <div className="text-xs text-[#6B7280] mt-1">
          {fault.site_dis} · {(fault.equips || []).join(", ") || "—"}
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {isAdmin && (
          <button
            onClick={onToggleCritical}
            disabled={busy}
            data-testid="fault-critical-toggle"
            className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-[11px] font-heading font-semibold ${
              fault.critical
                ? "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]"
                : "bg-white text-[#4D4D4D] border-[#E5E7EB] hover:border-[#B91C1C] hover:text-[#B91C1C]"
            }`}
            style={{ transition: "color .2s ease, border-color .2s ease" }}
          >
            <Star className="h-3 w-3" /> {fault.critical ? "Critical" : "Mark critical"}
          </button>
        )}
        <button onClick={onClose} data-testid="fault-detail-close" className="p-1.5 rounded-md border border-[#E5E7EB] text-[#6B7280] hover:text-[#212121]">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
